module.exports = __webpack_public_path__ + "precision-ocr-logo-stacked.a74ce61149a67774b0de58b27c1d5615.svg";